/**
 * カレンダー注釈をトリムし、表示テキストと表示可否を導出する。
 * トリム方針を1箇所に集約し、複数の表示箇所で判定と表示がずれないようにする。
 */
export const useCalendarNote = (calendarNote: () => string | undefined) => {
  const calendarNoteText = computed(() => calendarNote()?.trim() ?? '');
  const hasCalendarNote = computed(() => calendarNoteText.value.length > 0);
  return { calendarNoteText, hasCalendarNote };
};
